"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DropdownCard {
    constructor() {
        this.element = document.getElementById('dropdownCard');
        this.closeButton = document.getElementById('closeButton');
        this.init();
    }
    init() {
        if (!this.element)
            return;
        if (!this.closeButton)
            return;
        this.closeButton.addEventListener('click', () => this.hide());
        window.addEventListener('scroll', () => this.handleScroll());
    }
    handleScroll() {
        if (window.scrollY >= 100) {
            this.hide();
        }
    }
    hide() {
        if (!this.element)
            return;
        this.element.style.opacity = '0';
        setTimeout(() => {
            this.element.style.display = 'none';
        }, 300);
    }
}
exports.default = DropdownCard;
